<template>
    <div class="block__contacts tw-w-full">
        <div class="tw-flex">
            <div class="tw-bg-white tw-flex tw-justify-between tw-mb-4 tw-p-4 tw-rounded tw-w-full">
                <div>To:</div>
                <input type="text"
                    class="tw-min-h-0 tw-ml-2 tw-outline-none tw-resize-none tw-text-grey-darker tw-w-full tw-leading-none"
                    placeholder="Type a name, phone number or email"
                    @input="debounceSearchContact" v-model="searchContact">
            </div>
            <button class="btn btn-primary tw-mb-4 tw-ml-4" @click="newContact" title="New Contact"
                data-toggle="tooltip">
                <i class="fas fa-plus"></i>
            </button>
        </div>

        <card-spinner v-if="loading" style="height: 200px;"/>

        <div v-else id="contactList"
            class="tw-bg-white tw-rounded tw-overflow-y-auto tw-h-full"
            style="height: calc(100vh - 251px); min-height: 400px;">
            <ul v-if="contacts && contacts.data && contacts.data.length" class="tw-list-reset">
                <li v-for="contact in contacts.data" :key="contact.id"
                    class="hover:tw-bg-grey-lightest tw-border-b tw-cursor-pointer tw-p-4 tw-flex"
                    @click="startChatWith(contact)">
                    <div class="tw-mr-4 tw-mt-1 tw-rounded-full tw-text-center tw-w-10 tw-uppercase"
                        :class="contact.color"
                        style="line-height: 40px;font-size: 1.3em;">
                        {{ contact.initial }}
                    </div>
                    <div>
                        {{ contact.name }}
                        <div class="tw-font-light tw-text-sm">
                            {{ contact.phone_number }}
                            <span v-if="contact.phone_number && contact.email"> | </span>
                            {{ contact.email }}
                        </div>
                    </div>
                </li>
                <li v-if="contacts.meta && (contactsPage < contacts.meta.last_page || loadingContacts)"
                    class="hover:tw-bg-grey-lightest tw-border-b tw-cursor-pointer tw-p-4 tw-text-center hover:tw-text-blue"
                    :class="{'tw-cursor-wait': loadingContacts}"
                    @click="loadMoreContacts()">
                    <span v-if="loadingContacts"><card-spinner/></span>
                    <span v-else>Load more</span>
                </li>
            </ul>
            <div v-else class="tw-text-center">
                <draw-empty class="tw-h-64 tw-my-20 tw-w-full"/>
                <div class="tw-m-auto tw-mb-6 tw-text-2xl tw-w-1/3">
                    We couldn't find the contact that you are looking for.
                </div>
                <button class="btn btn-primary tw-text-xl" @click="newContact">
                    Create a new contact
                </button>
            </div>
        </div>

        <add-new-contact-modal @saved="contactSaved"/>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                contacts: {},
                searchContact: '',
                contactsPage: 1,
                loading: true,
                loadingContacts: false
            };
        },

        methods: {
            debounceSearchContact: _.debounce(function(e) {
                this.searchContact = e.target.value;
                this.contactsPage = 1;
                this.getContact();
            }, 600),

            async getContact(append = false) {
                const params = {
                    with: true,
                    search: this.searchContact,
                    paginate: true,
                    withPhone: true,
                    page: this.contactsPage
                };
                const uri = this.$laroute.route('api.contacts.select', params);
                const { data } = await this.$http.get(uri);

                const newData = data.data.map(i => ({
                    ...i,
                    color: this.randomColor(),
                    initial: i.name
                        ? this.getInitials(i.name)
                        : this.getInitials(i.phone_number)
                }));

                if (append) {
                    this.contacts.data = this.contacts.data.concat(newData);
                } else {
                    this.contacts = { ...data, data: newData };
                }

                this.loading = false;
            },

            async loadMoreContacts() {
                if (this.loadingContacts) return;
                this.loadingContacts = true;
                this.contactsPage++;
                await this.getContact(true);
                this.loadingContacts = false;
            },

            randomColor() {
                return _.sample([
                    'tw-bg-indigo-lightest tw-text-indigo-dark',
                    'tw-bg-blue-lighter tw-text-blue',
                    'tw-bg-green-lightest tw-text-green',
                    'tw-bg-yellow-lighter tw-text-yellow-dark',
                    'tw-bg-purple-lightest tw-text-purple',
                    'tw-bg-pink-lightest tw-text-pink-dark'
                ]);
            },

            getInitials(value) {
                const splittedValue = value.trim().split(' ');
                return splittedValue.length === 1
                    ? splittedValue[0][0] + splittedValue[0][1]
                    : splittedValue[0][0] + splittedValue[1][0];
            },

            newContact() {
                const data = { block: false };

                if (/\d/.test(this.searchContact))
                    data.phone_number = this.searchContact;
                else if (/@/.test(this.searchContact))
                    data.email = this.searchContact;
                else data.name = this.searchContact;

                window.Bus.$emit('openAddNewContactModal', data);
            },

            contactSaved(phone) {
                this.searchContact = phone;
                this.contactsPage = 1;
                this.getContact();
            },

            startChatWith(contact) {
                this.searchContact = '';
                this.$emit('startChat', contact);
            }
        }
    };
</script>

<style lang="scss" scoped>
</style>
